import { lazy } from 'react'

export const FastingFeedbackV1 = lazy(() => import('./v1/FastingFeedbackV1'))
export const FastingFeedbackV2 = lazy(() => import('./v2/FastingFeedbackV2'))
